export default "__VITE_ASSET__BJN6DHva__"